
import {useState} from 'react';
import TextField from "../../fragments/form/TextField"
import CheckboxSelector from "../../fragments/form/CheckboxSelector"
import SubmitButton from "../../fragments/form/SubmitButton"


function CreateCountryForm(props) {
    const [formData, setFormData] = useState(new FormData());

    const onChange = (id, value) => {
        formData.set(id, value);
        setFormData(formData);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        props.onSubmit(formData)
    }

    return (
        <form onSubmit={onSubmit}>
            <TextField id="country" required={true} onChange={onChange} label="Name" onLoad={() => onChange("country", "")}  />
            <TextField id="country_code" required={true} onChange={onChange} label="Country Code" onLoad={() => onChange("country_code", "")}  />
            <CheckboxSelector id="is_published" required={true} onChange={onChange} label="Publish" onLoad={() => onChange("is_published", "0")} />
            <SubmitButton />
        </form>
    );
}

export default CreateCountryForm;